import { Helmet } from "react-helmet";
import BGImage from "../../../assets/images/pexels-ga-huy-410696.jpg";
import Header from "../../../components/header";

export default function BuildingAutomationSupport() {
  // flex flex-col h-full w-full justify-center
  const headerContent = (
    <div className="flex flex-col justify-center w-full h-full">
      <h1 className="drop-shadow-lg text-4xl sm:text-6xl font-bold text-white ">
        Building Automation Support
      </h1>
      <p className="drop-shadow-lg text-white text-xl sm:text-2xl font-semibold mt-4 w-full">
        Discover how our clients maintain their buildings of tomorrow at a
        lesser cost.
      </p>
    </div>
  );

  return (
    <div className="flex flex-col justify-center w-full">
      <Helmet>
        <title>Building Automation Support - Services | Applied BAS</title>
        <meta charset="UTF-8" />
        <meta
          name="description"
          content="Applied BAS provides comprehensive building automation support services including servicing, preventative maintenance, on-site training, alarm management, and remote tech support. Expert BAS support in Dallas-Fort Worth."
        />
        <meta name="keywords" content="Building Automation Support, BAS Maintenance, BAS Servicing, Preventative Maintenance, BAS Training, Alarm Management, BAS Tech Support, Building Automation Service Dallas, BAS Support DFW, Remote BAS Support, On-site BAS Training" />
        <meta name="author" content="Applied BAS LLC" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.appliedbas.com/services/building-automation-support" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.appliedbas.com/services/building-automation-support" />
        <meta property="og:title" content="Building Automation Support - Services | Applied BAS" />
        <meta property="og:description" content="Applied BAS provides comprehensive building automation support services including maintenance, training, and tech support. Serving Dallas-Fort Worth." />
        <meta property="og:image" content="https://www.appliedbas.com/ABAS_logo.png" />
        <meta property="og:site_name" content="Applied BAS" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://www.appliedbas.com/services/building-automation-support" />
        <meta name="twitter:title" content="Building Automation Support - Services | Applied BAS" />
        <meta name="twitter:description" content="Applied BAS provides comprehensive building automation support services including maintenance and tech support. Serving Dallas-Fort Worth." />
        <meta name="twitter:image" content="https://www.appliedbas.com/ABAS_logo.png" />
      </Helmet>
      <Header content={headerContent} image={BGImage} />
      <section className="py-8 px-4 lg:px-8 w-full">
        <div className="w-full max-w-[1250px] m-auto">
          <p className="text-primarydark">Support</p>
          <h1 className="text-4xl font-bold">Servicing</h1>
          <p className="mt-4">
            We help maintain or repair any BAS equipment already installed in a
            building. However, some devices might get old or broken over the
            years of use, so our team of technicians with vast experience will
            help remedy these issues.{" "}
          </p>
        </div>
        <div className="w-full max-w-[1250px] m-auto mt-12">
          <h1 className="text-4xl font-bold">Preventative Maintenance</h1>
          <p className="mt-4">
            Preventive Maintenance is an excellent service that helps keep BAS
            in a good state. Unfortunately, already-installed systems degrade
            over time, so our top priority is to keep our clients from spending
            more on unnecessary equipment and help maintain these systems to
            keep them in great shape.
          </p>
        </div>
        <div className="w-full max-w-[1250px] m-auto mt-12">
          <h1 className="text-4xl font-bold">On-site Client Training</h1>
          <p className="mt-4">
            To help our clients use our services, we provide the proper training
            to utilize our services and clarify building automation management.
            Most of our services are easy to handle and very fast to comprehend.
            It only takes a couple of sessions for our clients to understand the
            software solutions they will use.
          </p>
        </div>
        <div className="w-full max-w-[1250px] m-auto mt-12">
          <h1 className="text-4xl font-bold">Alarm Management</h1>
          <p className="mt-4">
            Thanks to our custom web-based and IoT solutions, we can handle all
            alarms and allow our clients to manage them fast. Our solutions
            include viewing past warnings in the system, taking immediate action
            if an alarm is serious, and silencing any inaccurate notices.
          </p>
        </div>
        <div className="w-full max-w-[1250px] m-auto mt-12">
          <h1 className="text-4xl font-bold">
            On-site and remote Tech Support
          </h1>
          <p className="mt-4">
            If it so happens that our clients need our support, we provide the
            help as required. However, if the issues happen to be an emergency,
            our team will promptly solve them, whether it involves remote or
            on-site troubleshooting.
          </p>
        </div>
      </section>
    </div>
  );
}
